import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

function GetRequest() {
  var url = location.search; //获取url中"?"符后的字串
  var theRequest = new Object();
  if (url.indexOf("?") != -1) {
    var str = url.substr(1);
    var strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
    }
  }
  return theRequest;
}

// 调用方式
var urlParams = GetRequest();
//获取期刊id参数
var editId = urlParams["editId"];
var perId = urlParams["perId"];
window.sessionStorage.setItem("editId", editId);
window.sessionStorage.setItem("perId", perId);
//获取采编id参数
var userid = urlParams["userid"];
// window.sessionStorage.setItem('ids', ids)
window.sessionStorage.setItem("userid", userid);
var userId = "";
var userName = "";
if (JSON.parse(window.sessionStorage.getItem("userInfo"))) {
  userId = JSON.parse(window.sessionStorage.getItem("userInfo")).user.id
    ? JSON.parse(window.sessionStorage.getItem("userInfo")).user.id
    : "";
  userName = JSON.parse(window.sessionStorage.getItem("userInfo")).user.username
    ? JSON.parse(window.sessionStorage.getItem("userInfo")).user.username
    : "";
}

export default new Vuex.Store({
  state: {
    token: window.sessionStorage.getItem("token"),
    logding: false,
    qikanId: perId,
    cbianId: editId,
    userId: userId,
    userName: userName,
    periodicalIntro: "",
    linkName:"",
    eventStatus:false,
    linkType:false
  },
  getters: {
    addList(state) {
      return (state.logding = true);
    },
  },
  mutations: {
    addList(state) {
      return (state.logding = true);
    },
    changeStatus(state,status) {  //  重复赋值
      state.eventStatus = status;
    },
  },
  actions: {},
  modules: {},
});
